import { render, staticRenderFns } from "./EmployeeBranchEdit.vue?vue&type=template&id=8ecb9e54&scoped=true&"
import script from "./EmployeeBranchEdit.vue?vue&type=script&lang=js&"
export * from "./EmployeeBranchEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ecb9e54",
  null
  
)

export default component.exports